module.exports = __webpack_public_path__ + "img/23.804fc124.jpg";